<oui-table
  lineSizing="dense"
  class="board">
  <table
    mat-table
    [dataSource]="dataSource"
    matSort>
    <ng-container matColumnDef="type">
      <td
        mat-cell
        *matCellDef="let element"
        class="cell-investisseur">
        <div class="item-infos">
          <oui-tag
            type="status"
            status="pending">
            {{ element.statutCode | titlecase }}
          </oui-tag>
        </div>
      </td>
    </ng-container>
    <ng-container matColumnDef="nom">
      <td
        mat-cell
        *matCellDef="let element"
        class="cell-investisseur">
        <div class="item-infos">
          @if (element.personnePhysique?.[0]) {
            {{ element.personnePhysique[0].nom }} {{ element.personnePhysique[0].prenom }}
          }
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="dateNaissance">
      <td
        mat-cell
        *matCellDef="let element"
        class="cell-investisseur">
        <div class="item-infos">
          @if (element.personnePhysique?.[0]) {
            née le {{ $safeNavigationMigration(element.personnePhysique?.[0]?.dateNaissance) | date: 'shortDate' }}
          }
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="option">
      <td
        mat-cell
        *matCellDef="let element"
        class="cell-investisseur">
        @if (!isRelation($safeNavigationMigration(element.personnePhysique?.[0]?.id)) || doubleRelationAllowed()) {
          <div class="item-infos">
            <oui-button
              type="icon"
              [ouiTooltip]="'Ajouter comme ' + tooltipName()"
              color="primary"
              [disabled]="isReadOnly()"
              (click)="selectInvestisseur(element)">
              <oui-icon>add</oui-icon>
            </oui-button>
          </div>
        }
      </td>
    </ng-container>

    <ng-container>
      <tr
        [class.interactive]="!isRelation($safeNavigationMigration(row.personnePhysique?.[0]?.id))"
        [ouiTooltip]="isRelation($safeNavigationMigration(row.personnePhysique?.[0]?.id)) ? relatedPersonneTooltip() : ''"
        mat-row
        *matRowDef="let row; columns: displayedColumns"></tr>
    </ng-container>
  </table>

  @if (totalCount > 20) {
    <oui-paginator
      class="paginator"
      [pageSizeOptions]="pageSizeOptions"
      [length]="totalCount"
      [pageIndex]="pageIndex"
      [pageSize]="pageSize">
    </oui-paginator>
  }
</oui-table>
